import { Button } from '@/components/ui/button';
import { Columns2, AlignLeft } from 'lucide-react';
import type { ViewMode } from '@/hooks/use-view-mode-persistence';

interface DiffViewModeToggleProps {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
}

/**
 * Toggle control for switching between split and unified diff view modes.
 *
 * - Split view: Side-by-side comparison (default)
 * - Unified view: Single-column sequential comparison
 */
export function DiffViewModeToggle({ value, onChange }: DiffViewModeToggleProps) {
  return (
    <div className="flex gap-1 border rounded-md p-1">
      <Button
        variant={value === 'split' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onChange('split')}
        aria-label="Split view"
        className="gap-2"
      >
        <Columns2 className="h-4 w-4" />
        Split
      </Button>
      <Button
        variant={value === 'unified' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onChange('unified')}
        aria-label="Unified view"
        className="gap-2"
      >
        <AlignLeft className="h-4 w-4" />
        Unified
      </Button>
    </div>
  );
}
